import { render } from "./TabBot.vue?vue&type=template&id=303adffa&scoped=true"
import script from "./TabBot.vue?vue&type=script&lang=js"
export * from "./TabBot.vue?vue&type=script&lang=js"

import "./TabBot.vue?vue&type=style&index=0&id=303adffa&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303adffa"]])

export default __exports__